var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47 47",
    style: {
      enableBackground: "new 0 0 47 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA9B73;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.5,
    cy: 23.5,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,40.5c-0.4-2.2-4.8-5.5-4.8-5.5L29.5,20.5c0.3-0.2,0.7-0.4,1-0.6C39.1,14.2,43.3,5,41.3-2.3 c0.2,6.4-3.8,14.4-10.9,19.7C35,9.1,35-0.1,30.5-5.6c2.5,5.4,2.6,13.6-0.9,20.9c0.4-9-3.5-16.8-9.6-19.8c5.2,4.4,9,13.7,7.7,23 c0,0,0,0.1,0,0.1c-0.2,0.4-0.5,0.7-0.7,1.1c-7.3,3.9-15.3,4.1-20.9,1.6c4.4,3.4,11,4.1,17.7,2c-4.9,4.5-11,6.8-16.2,6.8 c6.2,1.6,13.7-1.3,19.2-7.5c-2.3,7.3-7.5,12.5-12.8,14.9c6.6-1.1,12.4-7.4,14.7-15.9c2.6,2.1,11.3,9.3,13.7,12.1 c2.9,3.3,4,7.4,5.1,8.8C48.5,43.8,50.3,42.7,50,40.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedBrown);
export default __webpack_public_path__ + "static/media/seed-brown.350aa3748465899f1aefb90defbb0e6b.svg";
export { ForwardRef as ReactComponent };